import React from 'react';

export default function Avatar({ className,dataHook }) {
  return (
    <svg data-hook={dataHook} xmlns="http://www.w3.org/2000/svg" width="92" height="92" viewBox="0 0 92 92" className={className}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#EAF7FF"
          stroke="#FFF"
          strokeWidth="4"
          d="M46 90C21.7 90 2 70.3 2 46S21.7 2 46 2s44 19.7 44 44-19.7 44-44 44z"
        />
        <path
          fill="#C1E4FE"
          d="M14.779 75c7.14-9.786 18.9-16.167 32.388-16.167 12.178 0 23.178 5.796 30.271 14.812C69.701 82.41 58.418 88 46 88c-12.364 0-23.402-5.017-31.221-13zM46 56.5c9.02 0 16.333-7.313 16.333-16.333 0-9.021-7.312-16.334-16.333-16.334-9.02 0-16.333 7.313-16.333 16.334 0 9.02 7.312 16.333 16.333 16.333z"
        />
      </g>
    </svg>
  );
}

Avatar.displayName = 'Avatar';
